var map = {
	"./Container/index.vue": [
		"1f7j"
	],
	"./HelloWorld.vue": [
		"q/3a",
		39
	],
	"./academicianList/index.vue": [
		"u50X",
		0,
		42
	],
	"./article/AcademicianL.vue": [
		"ziVa",
		24
	],
	"./article/contectUs.vue": [
		"aDbI",
		9
	],
	"./article/corporate.vue": [
		"wElx",
		0,
		38
	],
	"./article/index.vue": [
		"wm3/",
		0,
		29
	],
	"./article/memorabilia.vue": [
		"IPFU",
		25
	],
	"./article/new_file.vue": [
		"Kbz6",
		22
	],
	"./article/page.vue": [
		"0Z83",
		0,
		31
	],
	"./article/talent.vue": [
		"Wbkj",
		0,
		36
	],
	"./breadcrumbNavigation/index.vue": [
		"Bkuz",
		0,
		28
	],
	"./category/oneColumns.vue": [
		"4OY4",
		0,
		34
	],
	"./category/searchResult.vue": [
		"2l+R",
		32
	],
	"./category/twoColumns.vue": [
		"cPAt",
		0,
		45
	],
	"./emptyFrame/index.vue": [
		"vyNR",
		35
	],
	"./index/index.vue": [
		"JXTs",
		1,
		0
	],
	"./index/screen1.vue": [
		"zRJf",
		0,
		18
	],
	"./index/screen2.vue": [
		"aGd2",
		4
	],
	"./index/screen3.vue": [
		"tXzJ",
		41
	],
	"./index/screen4.vue": [
		"BpKy",
		33
	],
	"./index/screen5.vue": [
		"txGb",
		10
	],
	"./index/screen6.vue": [
		"gWwh",
		2,
		0
	],
	"./index/screen7.vue": [
		"36YD",
		43
	],
	"./index/screen8.vue": [
		"GqaO",
		3
	],
	"./index/screen9.vue": [
		"zZta",
		0
	],
	"./joinUs/add.vue": [
		"RiVv",
		0
	],
	"./joinUs/article.vue": [
		"Rtzu",
		0,
		21
	],
	"./joinUs/index.vue": [
		"u7eS",
		0,
		17
	],
	"./layout/components/AppMain.vue": [
		"BoPo"
	],
	"./layout/components/Backtop.vue": [
		"640S",
		23
	],
	"./layout/components/foot.vue": [
		"xMJ+",
		0
	],
	"./layout/components/head.vue": [
		"17Rc",
		0
	],
	"./layout/components/headindex.vue": [
		"M69L",
		0,
		26
	],
	"./layout/components/prohead.vue": [
		"aRW0",
		0
	],
	"./layout/components/sidebar/index.vue": [
		"SRp+"
	],
	"./layout/index.vue": [
		"6f/g"
	],
	"./matrix/index.vue": [
		"57A4",
		37
	],
	"./menuHorizontal/index.vue": [
		"Ixu+",
		0,
		40
	],
	"./mindex/index.vue": [
		"BISU",
		27
	],
	"./oneStopSolution/index.vue": [
		"XjNF",
		30
	],
	"./product/biomedicine.vue": [
		"DfIV",
		0,
		13
	],
	"./product/digital.vue": [
		"L5RE",
		0,
		8
	],
	"./product/energy.vue": [
		"RrPJ",
		0,
		12
	],
	"./product/smartTraffic.vue": [
		"B9PX",
		0,
		15
	],
	"./product/smartWater.vue": [
		"tLov",
		0,
		14
	],
	"./product/tourism.vue": [
		"C4vI",
		0,
		16
	],
	"./solution/digital.vue": [
		"RFya",
		0,
		20
	],
	"./solution/hospital.vue": [
		"KP76",
		0,
		19
	],
	"./solution/researchProjects.vue": [
		"W4uU",
		0,
		5
	],
	"./solution/smartAgriculture.vue": [
		"MnWv",
		0,
		6
	],
	"./solution/smartTransportation.vue": [
		"SIh0",
		0,
		7
	],
	"./solution/smartWater.vue": [
		"Zdp+",
		0,
		11
	],
	"./table/index.vue": [
		"YBQJ",
		44
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*\.vue$
// module id = Opzk
// module chunks = 47